require('intersection-observer');

const DEP = require('./utils/dep');

DEP.init();
